module.exports = "<div class=\"auth-layout-container\">\n  <router-outlet></router-outlet>\n</div>"